export const caseInsensitiveCompare = (a: string, b: string) =>
  !a || !b ? false : a.toUpperCase() === b.toUpperCase();
